<template>
  <div
    id="buttonWrap"
    :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
  >
    <div
      v-if="user.user.role_type === 'leader'"
      class="tooltipButtonWrap"
    >
      <el-tooltip
        class="tooltip"
        effect="dark"
        content="The report will be available after your next session"
        placement="top"
        :disabled="canShowReportStatus"
      >
        <div>
          <el-button
            type="primary"
            round
            :disabled="!canShowReportStatus"
            @click="openReport(canShowReportStatus)"
          >
            View Report
          </el-button>
        </div>
      </el-tooltip>
    </div>

    <div v-else>
      <el-button
        type="primary"
        round
        @click="openReport(canShowReportStatus, true)"
      >
        View Report as Leader
      </el-button>
      <el-button
        type="primary"
        round
        @click="openReport(canShowReportStatus)"
      >
        View Report
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import qs from 'qs';

export default {
  props: {
    calledByHierarchy: {
      type: Boolean,
      default: false,
    },

    showType: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      currentSession: (state) => state.processStatus.process.session,
    }),

    canShowReportStatus() {
      return ['leaderEngagementPulse', 'engagementPulse'].includes(this.showType)
        || this.calledByHierarchy || this.currentSession > 6;
    },
  },

  methods: {
    openReport(flag, asLeader) {
      const params = {
        service: process.env.VUE_APP_SERVICE,
      };

      if (['leaderEngagementPulse', 'engagementPulse'].includes(this.showType)) {
        params.pastReport = true;
      }

      if (!params.pastReport && this.user.user.role_type === 'leader') {
        // const route = this.$router.resolve({ name: 'pulseReportLeader' });
        // window.open(route.href, '_blank');
        window.open(
          `${process.env.VUE_APP_PDF_REPORT_CLIENT}/pulse-report/${this.user.user.uuid}${qs.stringify(params, { addQueryPrefix: true })}`,
          '_blank',
        );
      } else {
        if (!asLeader && this.user.user.role_type !== 'leader') {
          params.byPass = true;
        }
        window.open(
          `${process.env.VUE_APP_PDF_REPORT_CLIENT}/pulse-report/${this.$route.params.id}${qs.stringify(params, { addQueryPrefix: true })}`,
          '_blank',
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #buttonWrap {
    display: flex;
    flex-wrap: wrap;

    .surveyButtonWrap {
      width: 170px;

      .surveyButton {
        word-break: break-word;
        white-space: normal;
        width: 100%;
        padding: 13px 0;
      }
    }

    .tooltip {
      .el-button {
        padding: 13px 0;

        &.is-disabled {
          background: #a1a1a1;
          border-color: #a1a1a1;
        }
      }
    }

    &.deskMode {
      .tooltip {
        width: 170px;

        .el-button {
          width: 190px;
        }
      }
    }

    &.mobileMode {
      padding: 0 0 20px;

      .tooltipButtonWrap {
        width: 100%;

        .tooltip {
          width: 100%;
          margin: 15px 0 0;

          .el-button {
            width: 100%;
          }
        }
      }
    }
  }
</style>
